const Statuses = {
  NOT_ACTIVE: "NOT_ACTIVE",
  CHECK_PHOTOS: "CHECK_PHOTOS",
  ACTIVE: "ACTIVE",
  DELETED_BY_HOST: "DELETED_BY_HOST",
  DELETED: "DELETED",
  INACTIVE: "INACTIVE",
};

const AccessibleStatuses = (({ ACTIVE, NOT_ACTIVE, INACTIVE }) => ({
  ACTIVE,
  NOT_ACTIVE,
  INACTIVE,
}))(Statuses);

const PublishedStatuses = (({ ACTIVE }) => ({
  ACTIVE,
}))(Statuses);

const FirstLevelAmenities = {
  AUDIOVISUAL: "audiovisual",
  BREAKOUT_AREA: "breakout_area",
  CATERING: "catering",
  EXTRA: "extra",
  OVERNIGHT_ACCOMODATION: "overnight_accomodation",
  PARKING: "parking",
  PUBLIC_TRANSPORT: "public_transport",
  WIFI: "wifi",
};

const SecondLevelAmenities = {
  CLOAKROOM: "cloakroom",
  DISABLED_ACCESS: "disabled_access",
  FLIPCHART: "flipchart",
  HEAT: "heat",
  HVAC: "hvac",
  LECTERN: "lectern",
  MIC_AUDIO: "mic_audio",
  NATURAL_LIGHT: "natural_light",
  OUTDOORS: "outdoors",
  PHONE: "phone",
  PRINT: "print",
  STAGE: "stage",
  TABLE: "table",
  TEA: "tea",
  WEDDING_LICENCE: "wedding",
  WHITEBOARD: "white_board",
};

const AmenitiesLabelsEnum = {
  [FirstLevelAmenities.AUDIOVISUAL]: "Audiovisual",
  [FirstLevelAmenities.BREAKOUT_AREA]: "Breakout area",
  [FirstLevelAmenities.CATERING]: "Catering",
  [FirstLevelAmenities.EXTRA]: "Extra",
  [FirstLevelAmenities.OVERNIGHT_ACCOMODATION]: "Overnight accomodation",
  [FirstLevelAmenities.PARKING]: "Parking",
  [FirstLevelAmenities.PUBLIC_TRANSPORT]: "Public transport",
  [SecondLevelAmenities.CLOAKROOM]: "Cloakroom",
  [SecondLevelAmenities.DISABLED_ACCESS]: "Disabled access",
  // [SecondLevelAmenities.FLIPCHART]: 'Flipchart',
  [SecondLevelAmenities.HEAT]: "Heat",
  [SecondLevelAmenities.HVAC]: "Air conditioning",
  [SecondLevelAmenities.LECTERN]: "Lectern",
  [SecondLevelAmenities.NATURAL_LIGHT]: "Natural light",
  [SecondLevelAmenities.OUTDOORS]: "Outdoor/Garden/Beach",
  [SecondLevelAmenities.PHONE]: "Telephone",
  [SecondLevelAmenities.PRINT]: "Print / Scan / copy",
  [SecondLevelAmenities.STAGE]: "Stage",
  [SecondLevelAmenities.TABLE]: "Table/chairs included",
  [SecondLevelAmenities.TEA]: "Tea",
  [SecondLevelAmenities.WEDDING_LICENCE]: "Wedding ceremony licence",
  [SecondLevelAmenities.WHITEBOARD]: "Whiteboards",
};

const AudiovisualOptions = {
  WHITEBOARD: "whiteboard",
  PA: "pa",
  MIC_SPEAKER: "mic_speaker",
  CONFERENCE_PHONE: "conference_phone",
  PROJECTOR_SCREEN: "projector_screen",
  TV_SCREEN: "tv_screen",
  FLIPCHART: "flipchart",
  WIFI: "wifi",
};

const AudiovisualLabelsEnum = {
  [AudiovisualOptions.WIFI]: "WiFi",
  [AudiovisualOptions.MIC_SPEAKER]: "Microphone",
  [AudiovisualOptions.PROJECTOR_SCREEN]: "Projector & Screen",
  [AudiovisualOptions.PA]: "Sound system",
  [AudiovisualOptions.TV_SCREEN]: "TV Screen",
  [AudiovisualOptions.FLIPCHART]: "Flipchart",
  [AudiovisualOptions.CONFERENCE_PHONE]: "Conference phone",
};

const AmenitiesLabels = {
  ...AmenitiesLabelsEnum,
  ...AudiovisualLabelsEnum,
};

const Layouts = [
  {
    tag: "layout_boardroom",
    copy: "Boardroom",
  },
  {
    tag: "layout_cabaret",
    copy: "Cabaret",
  },
  {
    tag: "layout_classroom",
    copy: "Classroom",
  },
  {
    tag: "layout_deskspace",
    copy: "Deskspace",
  },
  {
    tag: "layout_open_space",
    copy: "Open space",
  },
  {
    tag: "layout_restautrant",
    copy: "Restaurant",
  },
  {
    tag: "layout_theatre",
    copy: "Theatre",
  },
];

const PaymentModels = {
  HOUR: "hr",
  HOUR_DAY: "hd",
  DAY: "dy",
  RATE: "rt",
  PER_GUEST: "pg",
  MINIMUM_SPENT: "ms",
  poa: "poa",
  POA: "POA",
};

const PaymentModelsLabelsEnum = {
  [PaymentModels.HOUR]: "Hourly",
  [PaymentModels.DAY]: "Daily",
  [PaymentModels.HOUR_DAY]: "Hourly / Daily",
  [PaymentModels.RATE]: "Hourly / Daily",
  [PaymentModels.PER_GUEST]: "Price per guest",
  [PaymentModels.MINIMUM_SPENT]: "Minimum spent",
  [PaymentModels.POA]: "Price on asking",
  [PaymentModels.poa]: "Price on asking",
};

const ParkingInfoTypes = {
  NONE: "none",
  ONSITE_FREE: "on_site_free",
  ONSITE_PAID: "on_site_paid",
  "5MIN_FREE": "5_mins_free",
  "5MIN_PAID": "5_mins_paid",
};

const ParkingInfoLabels = {
  [ParkingInfoTypes.NONE]: "No parking available",
  [ParkingInfoTypes.ONSITE_FREE]: "On-site, free",
  [ParkingInfoTypes.ONSITE_PAID]: "On-site, paid",
  [ParkingInfoTypes["5MIN_FREE"]]: "Within a 5-minute walk, free",
  [ParkingInfoTypes["5MIN_PAID"]]: "Within a 5-minute walk, paid",
};

const VenueStyles = {
  MODERN: "Modern",
  INDUSTRIAL: "Industrial",
  CHIC: "Chic",
  HIPSTER: "Hipster",
  FORMAL: "Formal",
  AFFORDABLE: "Affordable",
  BLANK_CANVAS: "Blank Canvas",
  CREATIVE: "Creative",
  ICONIC: "Iconic",
  PREMIUM: "Premium",
  QUIET: "Quiet",
  TRADITIONAL: "Traditional",
  UNUSUAL: "Unusual",
};

module.exports = {
  Status: Statuses,
  AccessibleStatuses,
  FirstLevelAmenities,
  PublishedStatuses,
  SecondLevelAmenities,
  AmenitiesLabelsEnum,
  AudiovisualOptions,
  AudiovisualLabelsEnum,
  AmenitiesLabels,
  Layouts,
  PaymentModels,
  PaymentModelsLabelsEnum,
  ParkingInfoTypes,
  ParkingInfoLabels,
  VenueStyles,
};
